import moment from 'moment'

const TemplateValidator = (t) => {
    moment.locale('es')
    let regexs = {
        nameRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,./;:¿?¡!()"'_-]+$/),
        descriptionRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.@/;:¿?¡!()"'_\-\n]+$/),
        commentsRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ,.@/;:¿?¡!()"'_-]+$/),
    }

    let validators = {
        nameValidator: (value) => {
            if (value) {
                if (value.length >= 100) {
                    return t('signature.request.nameLengthValidator')
                }
                if (value.length >= 0) {
                    return (regexs.nameRegex.test(value) ? "" : t('signature.request.nameValidator'))
                }
            }
        },
        descriptionValidator: (value) => {
            if (value.length > 0) {
                return (regexs.descriptionRegex.test(value) ? "" : t('signature.request.descriptionValidator'))
            }
        },
        commentsValidator: (value) => {
            if (value.length > 0) {
                return (regexs.commentsRegex.test(value) ? "" : t('signature.request.commentsValidator'))
            }
        }
    }

    return validators
}

export { TemplateValidator as default }
